export interface Size {
    sizeInBytes: number;
    humaneSize: string;
}
